import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data && data.access_token) setStoredToken(data.access_token);
if (data && data.id) setUser(data);
    return data;
  };

  const verify2fa = async (user_id, code) => {
    const { data } = await api.post("/auth/2fa/verify", { user_id, code });
    if (data && data.access_token) setStoredToken(data.access_token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data && data.access_token) setStoredToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(false);
setStoredToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verify2fa, register, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
